interface SkeletonBlockProps {
  className?: string;
}

const SkeletonBlock = ({ className = '' }: SkeletonBlockProps) => (
  <div
    className={`rounded-md bg-primary-100 dark:bg-secondary-dark-300 border border-secondary-400/60 ${className}`}
  />
);

export default SkeletonBlock;
